"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadTar = void 0;
const bzz_1 = require("../modules/bzz");
const http_1 = require("./http");
const tar_1 = require("./tar");
const tar_writer_1 = require("./tar-writer");
const bzzEndpoint = 'bzz';
async function uploadTar(requestOptions, collection, postageBatchId, options) {
    const tarStream = new tar_1.TarStream();
    await (0, tar_writer_1.writeTar)(collection, tarStream);
    await tarStream.end();
    const response = await (0, http_1.http)(requestOptions, {
        method: 'post',
        url: bzzEndpoint,
        data: tarStream.output,
        responseType: 'json',
        headers: {
            'content-type': 'application/x-tar',
            'swarm-collection': 'true',
            ...(0, bzz_1.extractCollectionUploadHeaders)(postageBatchId, options),
        },
    });
    return response;
}
exports.uploadTar = uploadTar;
